/**
 * Theme Requirements Aggregation for Price Brothers
 * 
 * Extends the base preferred theme requirements with Price Brothers specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-preferred/requirements';

/**
 * Price Brothers component requirement overrides.
 * Add requirements for any override components here.
 */
const pricebrothersOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Price Brothers theme.
 * Inherits from preferred theme and overrides with Price Brothers components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...pricebrothersOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
